
import { SessionStorage } from './storage'

const TokenKey = 'DCP-Token'

export function getToken() {
  return SessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return SessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return SessionStorage.removeItem(TokenKey)
}
